var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestMaticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    stroke: "#52555b",
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.641 23.286c-.614-.35-1.404-.35-2.105 0l-4.913 2.879-3.334 1.832-4.825 2.879c-.614.349-1.403.349-2.105 0l-3.773-2.268a2.124 2.124 0 01-1.052-1.833v-4.362c0-.698.35-1.395 1.052-1.832l3.773-2.18c.614-.35 1.403-.35 2.105 0l3.773 2.268a2.124 2.124 0 011.052 1.832v2.879l3.334-1.92v-2.966c0-.698-.351-1.396-1.053-1.832l-7.018-4.1c-.614-.35-1.404-.35-2.106 0l-7.193 4.187c-.702.35-1.053 1.047-1.053 1.745v8.2c0 .699.35 1.397 1.053 1.833l7.106 4.1c.614.349 1.403.349 2.105 0l4.825-2.792 3.334-1.919 4.825-2.792c.614-.349 1.404-.349 2.105 0l3.773 2.181a2.124 2.124 0 011.053 1.832V35.5c0 .698-.351 1.396-1.053 1.832l-3.685 2.181c-.614.35-1.404.35-2.105 0l-3.773-2.18a2.124 2.124 0 01-1.052-1.833v-2.791l-3.334 1.92v2.878c0 .698.35 1.396 1.053 1.832l7.106 4.1c.614.35 1.403.35 2.105 0l7.106-4.1a2.124 2.124 0 001.053-1.832v-8.288c0-.698-.351-1.396-1.053-1.832l-7.106-4.1z",
    fill: "#52555b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestMaticIcon);
export default __webpack_public_path__ + "static/media/test_matic_icon.097625a5cd28b0ea63e9766209d73846.svg";
export { ForwardRef as ReactComponent };